<template>



  <TsGrid :id="randomId" :cols="2"  noGutter appendClass="mb-5 gap-0 ">
    <TsColumn :appendClass="twMerge('is-12 p-0 ',props.reverse?'lg:order-2 order-1':'lg:order-1 '  )">
      <TsHeroBanner :backgroundImage="props.imageUrl" :class="twMerge(props.reverse?'max:lg:rounded-t-xl  ':'rounded-l-xl  lg:rounded-r-none rounded-b-none','  max-lg:rounded-t-xl  max-lg:rounded-b-none')" title=""  rootClass="mb-0 h-full bg-no-repeat bg-transparent border-none rounded-l-none"/>
    </TsColumn>
    <TsColumn :appendClass=" twMerge(' is-12 lg:p-0 px-4 bg-natural-soft-white ',props.reverse?'lg:order-1 order-2 border-x border-b max-lg:rounded-b-xl lg:rounded-l-xl lg:border-l lg:border-y':'lg:order-2  lg:rounded-r-xl lg:border-r lg:rounded-l-none border-x border-b max-lg:rounded-b-xl  lg:border-y ' ) ">
      <TsRow isMultiline class=" h-full items-center  lg:px-5">
        <TsColumn>
          <slot name="rightSection">
            <slot name="title">
              <TsTypography appendClass="mb-0" as="h2" >{{ props.title }}</TsTypography>
            </slot>
            <slot name="description">
              <TsTypography appendClass="mb-2 " as="p" >{{props.description}}</TsTypography>
            </slot>

            <TsTypography   v-if="!collapseCard" appendClass="underline underline-offset-2 cursor-pointer text-info" @click="showSubInfo()">
              {{ spanText }}</TsTypography>
            <slot name="content">
              <div v-if="collapseCard">
                <div v-for="(item,index) in props.cardContent" class="my-8" :key="item.id">
                  <TsTypography as="h2" >{{ index + 1 }}. {{ item.title }}</TsTypography>
                  <TsTypography appendClass="mb-2" as="p"  v-html="item.content"></TsTypography>
                </div>
                <TsTypography appendClass=" underline underline-offset-2 cursor-pointer text-info " @click="showSubInfo()">
                {{ spanText }}</TsTypography>
              </div>
            </slot>
            <TsButton append-class="mt-4 min-w-[168px]" v-if="buttonLabel">{{ buttonLabel }}</TsButton>
          </slot>
        </TsColumn>

      </TsRow>

    </TsColumn>
  </TsGrid>


</template>

<script setup lang="ts">
import {twMerge} from "tailwind-merge"
import {onMounted, ref,computed} from "vue";
import {useRandomUUID} from "~/composables/useRandomUUID";



const TsGrid = defineAsyncComponent(
    () => import('~/components/organisms/TsGrid.vue')
);

const TsHeroBanner = defineAsyncComponent(
    () => import('~/components/organisms/TsHeroBanner.vue')
);


const collapseCard = ref(false);
type Props = {
  imageUrl?: string,
  imagealt?: string | number,
  title?: string,
  description?: string,
  cardContent?: object[],
  layoutClass?:string,
  reverse?:boolean,
  buttonLabel: string;
}

const props = withDefaults(defineProps<Props>(), {
  imageUrl: "/images/TS-VSK 2024_00472 1.webp",
  title: "Vision And business Idea",

  description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  cardContent: () => ([
    {
      id: 1,
      title: "Lorem ipsum dolor sit amet.",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, " +
          "sed do eiusmod tempor incididunt ut labore et " +
          "dolore magna aliqua. Ut enim ad minim veniam, quis nostrud " +
          "exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat"
    }
  ]),
  reverse:false,
})

const emit = defineEmits<{
  toggleCollapse: [isCollapsed: boolean]
}>()

const showSubInfo = () => {
  collapseCard.value = !collapseCard.value
  emit('toggleCollapse' , collapseCard.value)
}
const spanText = computed(() => collapseCard.value ? useTranslation("Read Less", "Lees minder") : useTranslation("Read More", "Lees meer"))
const randomId = ref<string>("");
onMounted(() => {
  randomId.value = useRandomUUID();
});
</script>

